import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ApiConnectionItemFacade } from './api-connection-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ApiConnectionItemGuard {
  constructor(private apiConnectionItemFacade: ApiConnectionItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { apiConnectionId },
    } = route;
    return loadStoreState(this.apiConnectionItemFacade, apiConnectionId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.apiConnectionItemFacade);
  }
}
